import superagent from 'superagent'

export const termsSet = photos => ({
  type: 'TERMS_SET',
  payload: photos
})

export const termsFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/terms/get`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return
        }
        resolve(res.body)
        dispatch(termsSet(res.body))
        return res.body
      })
  })
}
